// fetchWithAuthRetry.js
import authService from "./auth.service";
import { showMessage } from "../customhooks/useNotifier";

const getAuthToken = () => {
  const currentAccessToken = localStorage.getItem("access_token");
  return currentAccessToken ? `Bearer ${currentAccessToken}` : "";
};

const fetchWithAuthRetry = async (url, options) => {
  let response = await fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: getAuthToken(),
    },
  });

  if (response.status === 401) {
    console.warn("Token expired, attempting to refresh...");
    const refreshResult = await authService.refreshToken();

    if (!refreshResult || !refreshResult.access_token) {
      showMessage("Session expired. Please log in again.", "error");
      localStorage.clear();
      window.location.href = "/signin";
      return;
    }

    // Retry the original request with the new token
    response = await fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${refreshResult.access_token}`,
      },
    });
  }

  return response;
};

export default fetchWithAuthRetry;